// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"user-badge_badgeWrapper__VgD1o","freeTrialCount":"user-badge_freeTrialCount__yyPOy"};